import React, { useEffect, useMemo, useState } from 'react'
import MasterService from '../../services/master/MasterService'
import { useNavigate } from 'react-router-dom'
import { Button, Col, Form, Row, Spinner } from 'react-bootstrap'
import Card from '../../components/Card'
import { FaMagnifyingGlass } from 'react-icons/fa6'
import { FaChevronCircleLeft, FaEraser, FaSave } from 'react-icons/fa'
import { AsyncPaginate } from 'react-select-async-paginate'
import UserService from '../../services/user/UserService'
import PartnerModal from './PartnerModal'
import SweetAlert from 'react-bootstrap-sweetalert'

const PartnerAddEdit = () => {
    let masterService = useMemo(() => new MasterService(), [])
    let userService = useMemo(() => new UserService(), [])
    let navigate = useNavigate()

    const [valueIdPartner, setValueIdPartner] = useState(null)
    const [valueNama, setValueNama] = useState(null)
    const [valueAlamat, setValueAlamat] = useState(null)
    const [valueNoId, setValueNoId] = useState(null)
    const [valueNegaraOpt, setValueNegaraOpt] = useState(null)
    const [disabledForm, setDisableForm] = useState(false)

    useEffect(() => {
        let dataPartnerExisting = JSON.parse(localStorage.getItem('dataPartnerStorage'))
        // console.log(dataPartnerExisting)
        if (!dataPartnerExisting) return
        const fetchAllData = async () => {
            try {
                setValueIdPartner(dataPartnerExisting.idPartner)
                setValueNama(dataPartnerExisting.nama)
                setValueAlamat(dataPartnerExisting.alamat)
                setValueNoId(dataPartnerExisting.noId)

                const resNeg = await masterService.getNegaraById(dataPartnerExisting.negara)
                setValueNegaraOpt(resNeg.data)
            } catch (error) {

            }
        }
        fetchAllData()
    }, [masterService])

    async function loadOptionNeg(search, loadedOption, { page = 1 }) {
        const response = await masterService.listNegara(search, page - 1, 10)
        return {
            options: response.data.data,
            hasMore: response.data.data.length >= 10,
            addition: {
                page: page + 1
            }
        }
    }

    const onChangeNama = e => {
        setValueNama(e.target.value)
    }

    const onChangeAlamat = e => {
        setValueAlamat(e.target.value)
    }

    const onChangeNoid = e => {
        setValueNoId(e.target.value)
    }

    const onChangeNeg = e => {
        setValueNegaraOpt(e)
    }

    const handleClickResetData = () => {
        setValueIdPartner('')
        setValueNama('')
        setValueNoId('')
        setValueAlamat('')
        setValueNegaraOpt(null)
        setDisableForm(false)
    }

    const handleClickBatal = () => {
        localStorage.removeItem('dataPartnerStorage')
        navigate('/setting/partner')
    }

    const handleClickCariPartner = () => {
        setShowPartnerModal(true)
    }

    const [showPartnerModal, setShowPartnerModal] = useState(false)
    const handleClosePartnerModal = async (row) => {
        setValueIdPartner(row.idPartner)
        setValueNama(row.nama)
        setValueAlamat(row.alamat)
        setValueNoId(row.noId)

        const resNeg = await masterService.getNegaraById(row.negara)
        setValueNegaraOpt(resNeg.data)

        setShowPartnerModal(false)
    }

    const [loadingSave, setLoadingSave] = useState(false)
    const [showConfirmSimpanPartner, setShowConfirmSimpanPartner] = useState(false)
    const handleCloseConfirmSimpanPartner = () => setShowConfirmSimpanPartner(false)
    const [showSimpanSuccess, setShowSimpanSuccess] = useState(false)
    const [showSimpanFailed, setShowSimpanFailed] = useState(false)

    const handleClickSimpan = () => {
        setShowConfirmSimpanPartner(true)
    }

    const handleClickProsesSimpan = async () => {
        try {
            setLoadingSave(true)
            let dataPartnerExisting = JSON.parse(localStorage.getItem("dataPartnerStorage"))
            // console.log(dataPartnerExisting)
            let jsonPartner = {
                ...dataPartnerExisting,
                idPartner: valueIdPartner !== null ? valueIdPartner : 0,
                nama: valueNama,
                alamat: valueAlamat,
                noId: valueNoId !== null ? valueNoId : '-',
                negara: valueNegaraOpt.kodeNegara,
                userId: localStorage.getItem('userId'),
                kodeTrader: Number(localStorage.getItem('kodeTrader'))
            }
            // console.log(jsonPartner)
            const resSimpanPartner = await userService.addPartnerTrader(jsonPartner)
            if (resSimpanPartner.data.kode === '200') {
                setShowSimpanSuccess(true)
                setShowConfirmSimpanPartner(false)
            } else {
                setShowSimpanFailed(true)
                setShowConfirmSimpanPartner(false)
            }
            setLoadingSave(false)
        } catch (error) {
            setLoadingSave(false)
            setShowSimpanFailed(true)
            setShowConfirmSimpanPartner(false)
        }
    }

    const handleCloseSimpanSuccess = () => {
        setLoadingSave(false)
        setShowSimpanSuccess(false)
        localStorage.removeItem('dataPartnerStorage')
        navigate('/setting/partner')
    }

    const handleCloseSimpanFailed = () => {
        setLoadingSave(false)
        setShowSimpanFailed(false)
        localStorage.removeItem('dataPartnerStorage')
        navigate('/setting/partner')
    }

    return (
        <>
            <div>
                <Row>
                    <Col sm="12" lg="13">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h5 className="card-title">{localStorage.getItem("dataPartnerStorage") !== null ? 'Ubah' : 'Tambah'}  Master Partner</h5>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nama Partner</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control type="text" placeholder="Nama Partner" className="form-control-sm" value={valueNama} onChange={onChangeNama} disabled={disabledForm} />
                                                </Col>
                                                <Col sm="1">
                                                    <Button color='outline-primary' size='sm' onClick={() => handleClickCariPartner()}><FaMagnifyingGlass /></Button>
                                                </Col>
                                                <Col sm="4">
                                                    <small>*) Silahkan klik untuk mencari seluruh data Partner</small>
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Nomor ID</Form.Label>
                                                <Col sm="3">
                                                    <Form.Control type='text' placeholder="Nomor Identitas" className="form-control-sm" value={valueNoId} onChange={onChangeNoid} disabled={disabledForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Alamat Partner</Form.Label>
                                                <Col sm="5">
                                                    <Form.Control as="textarea" rows={3} placeholder="Alamat Partner" className="form-control-sm" value={valueAlamat} onChange={onChangeAlamat} disabled={disabledForm} />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-10">
                                        <Form>
                                            <Form.Group as={Row} className="form-group">
                                                <Form.Label column sm="2" className="control-label align-self-center mb-0" htmlFor="searchNib">Negara</Form.Label>
                                                <Col sm="3">
                                                    <AsyncPaginate
                                                        loadOptions={loadOptionNeg}
                                                        value={valueNegaraOpt}
                                                        getOptionLabel={(option) => option.kodeNegara + ' - ' + option.uraianNegara}
                                                        getOptionValue={(option) => option.kodeNegara}
                                                        additional={{
                                                            page: 1
                                                        }}
                                                        onChange={onChangeNeg}
                                                        isDisabled={disabledForm}
                                                    />
                                                </Col>
                                            </Form.Group>
                                        </Form>
                                    </div>
                                </div>
                            </Card.Body>
                            <Card.Footer>
                                <Button variant="primary" size='sm' onClick={() => handleClickSimpan()}><FaSave /> Simpan</Button>{' '}
                                <Button variant="warning" size='sm' onClick={() => handleClickResetData()}><FaEraser /> Reset</Button>{' '}
                                <Button variant="danger" size='sm' onClick={() => handleClickBatal()}>
                                    <FaChevronCircleLeft /> Kembali
                                </Button>
                            </Card.Footer>
                        </Card>
                    </Col>
                </Row>
                <PartnerModal showPartnerModal={showPartnerModal} handleClosePartnerModal={handleClosePartnerModal} setDisabledForm={setDisableForm} />
                {
                    showConfirmSimpanPartner &&
                    <SweetAlert
                        title="Simpan Data Partner"
                        warning
                        showCancel
                        confirmBtnText={
                            loadingSave ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Proses Simpan...
                                </>
                            ) : (
                                "Simpan"
                            )
                        }
                        confirmBtnBsStyle="primary"
                        cancelBtnText="Batal"
                        cancelBtnBsStyle="secondary"
                        onConfirm={handleClickProsesSimpan}
                        onCancel={handleCloseConfirmSimpanPartner}
                        focusCancelBtn
                        btnSize="sm"
                        disabled={loadingSave}
                        reverseButtons={true}
                    >
                        {loadingSave && (
                            <div className="text-center">
                                <Spinner animation="border" variant="primary" />
                                <p className="mt-2">Proses Simpan data, harap tunggu...</p>
                            </div>
                        )}
                    </SweetAlert>
                }
                {
                    showSimpanSuccess &&
                    <SweetAlert
                        success
                        title="Simpan Data Partner Berhasil"
                        onConfirm={handleCloseSimpanSuccess}
                        btnSize="sm"
                    />
                }
                {
                    showSimpanFailed &&
                    <SweetAlert
                        danger
                        title="Simpan Data Partner Gagal"
                        onConfirm={handleCloseSimpanFailed}
                        btnSize="sm"
                        timeout={2000}
                    />
                }
            </div>
        </>
    )
}

export default PartnerAddEdit